<template>
  <v-container>
    <v-form v-model='valid' ref='form' lazy-validation>
    <v-layout row align-center class="my-3">
      <v-icon color="primary">gavel</v-icon>&nbsp;&nbsp;<span class="txt-titulo">Presentación mediante Apoderado</span>
    </v-layout>
      <v-layout align-center justify-end v-if='!modificar'>
        <v-btn fab color="primary" class="botonEdit" @click='modificarDatos()'>
          <v-icon>edit</v-icon>
        </v-btn>
      </v-layout>
      <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span><b>Apoderado:D.S. Nº1233 Art. 8.- (Presentación Mediante Apoderado).</b>
                <br>
                <p align="justify">En caso de impedimento para el llenado de forma  tradicional del Formulario Único de la Declaración Jurada de Bienes y Rentas, este podrá ser llenado, firmado y presentado ante la Contraloría General del Estado mediante apoderado, con poder especial que faculte el llenado, la firma y la presentación de la Declaración Jurada de Bienes y Rentas, detallando los datos respectivos.</p>
          </span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
        <v-flex xs12 sm12 md12 class="decretos">
          <alert-extendible texto="<b>Apoderado:D.S. Nº1233 Art. 8.- (Presentación Mediante Apoderado).</b>
            <br>
            <p align='justify'>En caso de impedimento para el llenado de forma  tradicional del Formulario Único de la Declaración Jurada de Bienes y Rentas, este podrá ser llenado, firmado y presentado ante la Contraloría General del Estado mediante apoderado, con poder especial que faculte el llenado, la firma y la presentación de la Declaración Jurada de Bienes y Rentas, detallando los datos respectivos.</p>"></alert-extendible>
        </v-flex> 
        <v-container>
        <v-layout wrap>
                  <v-flex sm6 md6>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator='{ on }'>
                        <v-text-field
                          v-on='on'
                          :rules="nroDocumentoRules"
                          :disabled='!modificar'
                          v-model='nroDocumento'
                          label='Número de Documento*'
                          maxlength='50'            
                        ></v-text-field>
                      </template>
                      <span>Digite el número del documento de identificación(SIN ESPACIOS VACIOS)</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex sm6 md6>
                    <v-autocomplete :disabled='!modificar' :rules="dRules" :no-data-text='this.dato' v-model='lugarExpedicion.dep_codigo' :items="itemsDep" item-text="dep_descripcion" item-value="dep_codigo" label="Expedido*"></v-autocomplete>
                  </v-flex>
                </v-layout>
                 <v-layout wrap>
                  <v-flex sm6 md6>
                    <v-text-field
                      v-model='apellidoPaterno'
                      label='Apellido Paterno'
                      :disabled='!modificar'
                      maxlength='60'
                      :rules="$validate(['text_area'])"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 md6>
                    <v-text-field
                      v-model='apellidoMaterno'
                      label='Apellido Materno'
                      maxlength='60'
                      :disabled='!modificar'
                      :rules="$validate(['text_area'])"
                    ></v-text-field>
                  </v-flex>
                  </v-layout>
                 <v-layout wrap>
                  <v-flex sm6 md6>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator='{ on }'>
                        <v-text-field
                          v-on='on'
                          v-model='nombres'
                          :disabled='!modificar'
                          :rules='textRules'
                          label='Nombres*'
                          required
                          maxlength='100'
                        ></v-text-field>
                      </template>
                      <span>Revise sus Apellidos y Nombres que esten transcritos correctamente.</span>
                    </v-tooltip>
                  </v-flex>
                   <v-flex sm6 md6>
                <v-text-field 
                v-model="correoElectronico"
                :disabled='!modificar'
                :rules='emailRules' 
                maxlength='50'
                label="Correo Electrónico Personal*"></v-text-field>
              </v-flex>
                </v-layout>
                <v-layout wrap>
                <v-flex xs12 sm6 md6>
                <v-text-field v-model="celular"
                 maxlength='30'
                 :disabled='!modificar' 
                 :rules="celularRules" 
                 label="Teléfono"></v-text-field>
              </v-flex>
               <v-flex xs12 sm6 md6>
                <v-text-field v-model="poderNotarial" 
                :disabled='!modificar' 
                :rules="textRules" 
                maxlength='50'
                label="Número de poder notariado*"></v-text-field>
              </v-flex>
            </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                <v-text-field v-model="direccion" 
                :disabled='!modificar' 
                :rules="textRules" 
                maxlength='100'
                label="Domicilio Actual (Calle/Avenida Nro, Zona)*"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-tooltip color="secondary" top>
                  <template v-slot:activator='{ on }'>
                    <v-textarea
                      @change="observaciones = $util.sanitiza(observaciones)"
                      v-model='observaciones'
                      label='Observaciones'
                      :disabled='!modificar'
                      counter
                      maxlength='250'
                      v-on='on'
                      hint='Máximo 250 caracteres.'
                      persistent-hint
                      :rules="$validate(['text_area'])"
                      rows="1"
                      auto-grow
                    ></v-textarea>
                     </template>
              <span> Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos de “Datos del apoderado”. 
            </span>
           </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-subheader>
                    <span class='plomo--text'>Por favor llene los campos requeridos*</span>
                  </v-subheader>
                </v-layout>
      </v-container>
      <v-btn color='primary' @click='modificarDatos()' v-show='!modificar'>
        <v-icon>create</v-icon>&nbsp;Modificar
      </v-btn>
      <v-card-actions>
         <v-spacer></v-spacer>
      <v-btn class="tamanioBoton" :loading='loadingButton' color='primary' @click='guardaDatosApoderado' v-show='modificar'>
        <v-icon>save</v-icon>&nbsp;Guardar
      </v-btn>
       <v-btn class="tamanioBoton" :loading='loadingButtonBorrar' color='warning' @click='eliminaDatosApoderado' v-show='modificar'>
        <v-icon>delete</v-icon>&nbsp;Borrar
      </v-btn>
      <v-btn class="tamanioBoton" color='error' v-show='modificar' @click='cancelarAction()'>
        <v-icon>cancel</v-icon>&nbsp;Cancelar
      </v-btn>
      </v-card-actions>
      <br>
       <v-layout align-center wrap>
        <v-flex md8 />
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click="$router.push('/parentesco')">
            <v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior
          </v-btn>
          <v-btn color='accent' @click="$router.push('/borrador')">
            Siguiente&nbsp;
            <v-icon right dark>arrow_forward_ios</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
  </v-form>
  </v-container>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [Parametricas, validate],
  created () {
    // this.navBarEmmit();
    this.obtieneDatos();
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === 2) {
          this.$message['warning'](
            'Su ultima Declaración no fue recepcionada, habilite la misma para terminarla'
          );
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === -1) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
      }
    });
    this.$service.get('djbr_registro/valida_declaracion', {}).then(response => {
      if (response[0] && response[0].err_existente !== 0) {
        this.$message['warning'](response[0].err_mensaje + ' ' + 'volver a Datos Generales');
        this.$router.push('datos-generales');
      }
    });
    this.cargarDepartamentos();
  },
  data: () => ({
    loadingButton: false,
    loadingButtonBorrar: false,
    lugarExpedicion: { dep_codigo: 0, dep_descripcion: '' },
    itemsDep: [],
    dato: 'No hay datos disponibles',
    nroDocumento: '',
    valid: false,
    apellidoPaterno: '',
    apellidoMaterno: '',
    nombres: '',
    correoElectronico: '',
    celular: '',
    poderNotarial: '',
    direccion: '',
    observaciones: '',
    apo_codigo: '',
    dialog: false,
    editMode: false,
    deleteMode: false,
    codError: null,
    msgError: null,
    statusError: null,
    modificar: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    emailRules: [ v => !!v || 'Este campo es requerido',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Ingrese un correo electrónico valido'],
    nroDocumentoRules: [
      v => !!v || 'Nro de documento es requerido',
      v => /^[A-Za-z0-9-]*$/.test(v) || 'El número de documento no es válido'
    ],
    celularRules: [
      v => !!v || 'Este campo es requerido',
      v => /^[0-9]*$/.test(v) || 'El número de celular no es válido'
    ]
  }),
  methods: {
    cargarDepartamentos () {
      this.$service
        .get(`departamentos`, {})
        .then(response => {
          if (response) {
            this.itemsDep = response;
          }
        });
    },
    setearDatos (response) {
      this.nroDocumento = response.apo_docidentidad.replace(/[^A-Z0-9]/g, '');
      this.lugarExpedicion.dep_codigo = response.dep_expedicion_codigo;
      this.apellidoPaterno = response.apo_appaterno;
      this.apellidoMaterno = response.apo_apmaterno;
      this.nombres = response.apo_nombres;
      this.correoElectronico = response.apo_correo_electronico;
      this.celular = response.apo_numero_telefono;
      this.poderNotarial = response.apo_numero_documento;
      this.direccion = response.apo_domicilio;
      this.observaciones = response.apo_observacion;
    },
    obtieneDatos () {
      this.$service.get(`djbr_registro/apoderado`).then(response => {
        if (response) {
          if (response.err_existente === 1) {
            this.modificar = true;
          } else {
            this.apo_codigo = response.apo_codigo;
          }
          this.setearDatos(response);
        } else {
          this.$message['warning'](`No se recuperaron datos personales..`);
        }
      });
    },
    guardaDatosApoderado () {
      if (!(!!this.apellidoPaterno || !!this.apellidoMaterno)) {
        this.$message['warning']('Al menos uno de los apellidos es requerido');
      }
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        if (this.apo_codigo !== '') {
          let params = {
            apo_codigo: this.apo_codigo,
            apo_docidentidad: this.nroDocumento,
            dep_expedicion_codigo: this.lugarExpedicion.dep_codigo,
            apo_appaterno: this.apellidoPaterno,
            apo_apmaterno: this.apellidoMaterno,
            apo_nombres: this.nombres,
            apo_correo_electronico: this.correoElectronico,
            apo_numero_telefono: this.celular,
            apo_numero_documento: this.poderNotarial,
            apo_domicilio: this.direccion,
            apo_observacion: this.observaciones
          };
          this.$service
            .put(`djbr_registro/apoderado`, params)
            .then(response => {
              if (response) {
                if (response.err_codigo === 0) {
                  this.loadingButton = false;
                  this.obtieneDatos();
                  this.editMode = false;
                  this.dialog = false;
                  this.cancelarAction();
                  this.$message['success'](response.err_mensaje);
                  let ctrl = this.$storage.get('ctrl');
                  this.$storage.set('ctrl', ctrl);
                } else {
                  this.$message['warning'](response.err_mensaje);
                  this.loadingButton = false;
                }
              } else {
                this.loadingButton = false;
              }
            })
          .catch(e => {
            console.log(e);
            this.loadingButton = false;
          });
        } else {
          let params = {
            apo_docidentidad: this.nroDocumento,
            dep_expedicion_codigo: this.lugarExpedicion.dep_codigo,
            apo_appaterno: this.apellidoPaterno,
            apo_apmaterno: this.apellidoMaterno,
            apo_nombres: this.nombres,
            apo_correo_electronico: this.correoElectronico,
            apo_numero_telefono: this.celular,
            apo_numero_documento: this.poderNotarial,
            apo_domicilio: this.direccion,
            apo_observacion: this.observaciones
          };
          this.$service
            .post(`djbr_registro/apoderado`, params)
            .then(response => {
              if (response) {
                if (response.err_codigo === 0) {
                  this.loadingButton = false;
                  this.obtieneDatos();
                  this.cancelarAction();
                  this.editMode = false;
                  this.dialog = false;
                  this.$message['success'](response.err_mensaje);
                  let ctrl = this.$storage.get('ctrl');
                  this.$storage.set('ctrl', ctrl);
                } else {
                  this.$message['warning'](response.err_mensaje);
                  this.loadingButton = false;
                }
              } else {
                this.loadingButton = false;
              }
            })
          .catch(e => {
            console.log(e);
            this.loadingButton = false;
          });
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    reinicializa () {
      this.nroDocumento = '';
      this.lugarExpedicion.dep_codigo = 0;
      this.apellidoPaterno = '';
      this.apellidoMaterno = '';
      this.nombres = '';
      this.apo_codigo = '';
      this.correoElectronico = '';
      this.celular = '';
      this.poderNotarial = '';
      this.direccion = '';
      this.observaciones = '';
      this.$refs.form.resetValidation();
    },
    eliminaDatosApoderado () {
      this.loadingButtonBorrar = true;
      if (this.apo_codigo === -1 || this.apo_codigo === '') {
        this.$message['warning']('No se encuentra registros para borrar');
        this.loadingButtonBorrar = false;
      } else {
        this.$service
          .delete('djbr_registro/apoderado/' + this.apo_codigo)
          .then(response => {
            if (response) {
              if (response.err_codigo === 0) {
                this.loadingButtonBorrar = false;
                this.reinicializa();
                this.$message['success'](response.err_mensaje);
              } else {
                this.$message['warning'](response.err_mensaje);
                this.loadingButtonBorrar = false;
              }
            }
          })
          .catch(e => {
            console.log(e);
            this.loadingButtonBorrar = false;
          });
      }
    },
    cancelarAction () {
      this.cod_error = null;
      this.$refs.form.resetValidation();
      this.modificar = !this.modificar;
      this.obtieneDatos();
      let ctrl = this.$storage.get('ctrl');
      this.$storage.set('ctrl', ctrl);
    },
    modificarDatos () {
      this.modificar = !this.modificar;
      let ctrl = this.$storage.get('ctrl');
      this.$storage.set('ctrl', ctrl);
    }
  }
};
</script>
<style lang='scss'>
.txt-danger {
  color: #f55656;
}
.txt-info {
  color: #5484cc;
}
.v-btn__content_validar {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/declaracion/apoderado.vue